import React from 'react';
import { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import { setUser } from '../actions';
import Header from '../components/Header';
import Chat from '../components/Chat';
import Webareal from '../components/Webareal';
import MtoknaBanners from '../components/MtoknaBanners';
import { Navigate } from './Navigate';
import {getCustomizationKey, getDeviceToken, getMarket} from '../functions';
import {
    COOKIE_DEVICE_TOKEN_NAME,
    COOKIE_SETTINGS,
    CUSTOM_ORDER_PAGES
} from '../config';
import '../assets/styles/content.css';

const DashboardScreen = lazy(() => import('../screens/DashboardScreen'));
const OrdersScreen = lazy(() => import('../screens/OrdersScreen'));
const ClientsScreen = lazy(() => import('../screens/ClientsScreen'));
const InvoicesScreen = lazy(() => import('../screens/InvoicesScreen'));
const InvoicePaymentsScreen = lazy(() => import('../screens/InvoicePaymentsScreen'));
const LabelsScreen = lazy(() => import('../screens/LabelsScreen'));
const ExportsScreen = lazy(() => import('../screens/ExportsScreen'));
const TemplatesScreen = lazy(() => import('../screens/TemplatesScreen'));
const TemplateScreen = lazy(() => import('../screens/TemplateScreen'));
const ExportScreen = lazy(() => import('../screens/ExportScreen'));
const BmailsScreen = lazy(() => import('../screens/BmailsScreen'));
const AddonsScreen = lazy(() => import('../screens/AddonsScreen'));
const EshopScreen = lazy(() => import('../screens/EshopScreen'));
const AccountingScreen = lazy(() => import('../screens/AccountingScreen'));
const StorageScreen = lazy(() => import('../screens/StorageScreen'));
const LoginScreen = lazy(() => import('../screens/LoginScreen'));
const RegisterScreen = lazy(() => import('../screens/RegisterScreen'));
const EmployeesScreen = lazy(() => import('../screens/EmployeesScreen'));
const EmployeeScreen = lazy(() => import('../screens/EmployeeScreen'));
const NotificationsScreen = lazy(() => import('../screens/NotificationsScreen'));
const SettingsScreen = lazy(() => import('../screens/SettingsScreen'));
const MarketplacesScreen = lazy(() => import('../screens/MarketplacesScreen'));
const AdminScreen = lazy(() => import('../screens/AdminScreen'));
const PublicScreen = lazy(() => import('../screens/PublicScreen'));
const OrderScreen = lazy(() => import('../screens/OrderScreen'));
const TrackTraceScreen = lazy(() => import('../screens/TrackTraceScreen'));
const ComplaintsScreen = lazy(() => import('../screens/ComplaintsScreen'));
const ComplaintScreen = lazy(() => import('../screens/ComplaintScreen'));
const OrderPublic = lazy(() => import('../screens/OrderPublic'));
const AffiliateLoginScreen = lazy(() => import('../screens/AffiliateLoginScreen'));
const AffiliateRegisterScreen = lazy(() => import('../screens/AffiliateRegisterScreen'));
const AffiliatePortalScreen = lazy(() => import('../screens/AffiliatePortalScreen'));
const OrderMtOknaScreen = lazy(() => import('../screens/OrderMtOknaScreen'));
const MtoknaOrdersScreen = lazy(() => import('../screens/MtoknaOrdersScreen'));
const MtoknaSellersScreen = lazy(() => import('../screens/MtoknaSellersScreen'));
const MtoknaOwnersScreen = lazy(() => import('../screens/MtoknaOwnersScreen'));
const MtoknaPointsScreen = lazy(() => import('../screens/MtoknaPointsScreen'));
const MtoknaCreateOrderScreen = lazy(() => import('../screens/MtoknaCreateOrderScreen'));
const MtoknaManualOrdersScreen = lazy(() => import('../screens/MtoknaManualOrdersScreen'));
const MtoknaTemplatesScreen = lazy(() => import('../screens/MtoknaTemplatesScreen'));
const MtoknaTemplateScreen = lazy(() => import('../screens/MtoknaTemplateScreen'));
const MtoknaOwnerSmtpScreen = lazy(() => import('../screens/MtoknaOwnerSmtpScreen'));
const MtoknaEshopScreen = lazy(() => import('../screens/MtoknaEshopScreen'));
const MtoknaFilesScreen = lazy(() => import('../screens/MtoknaFilesScreen'));
const MtoknaBannersScreen = lazy(() => import('../screens/MtoknaBannersScreen'));
const CabProductsScreen = lazy(() => import('../screens/CabProductsScreen'));
const MtoknaManualSellerOrdersScreen = lazy(() => import('../screens/MtoknaManualSellerOrdersScreen'));
const MtoknaModeratorsScreen = lazy(() => import('../screens/MtoknaModeratorsScreen'));
const MtoknaManualCustomerOrdersScreen = lazy(() => import('../screens/MtoknaManualCustomerOrdersScreen'));
const MtoknaComplaintsScreen = lazy(() => import('../screens/MtoknaComplaintsScreen'));
const MtoknaCategoriesScreen = lazy(() => import('../screens/MtoknaCategoriesScreen'));
const MtoknaProductsScreen = lazy(() => import('../screens/MtoknaProductsScreen'));
const MtoknaCreateProductScreen = lazy(() => import('../screens/MtoknaCreateProductScreen'));
const MtoknaSchemesScreen = lazy(() => import('../screens/MtoknaSchemesScreen'));
const MtoknaCreateSchemeScreen = lazy(() => import('../screens/MtoknaCreateSchemeScreen'));
const MtoknaDogsScreen = lazy(() => import('../screens/MtoknaDogsScreen'));
const MtoknaCreateDogScreen = lazy(() => import('../screens/MtoknaCreateDogScreen'));
const MtoknaDogProductsScreen = lazy(() => import('../screens/MtoknaDogProductsScreen'));
const MtoknaWindowSettingsScreen = lazy(() => import('../screens/MtoknaWindowSettingsScreen'));
const MtoknaWindowSellerScreen = lazy(() => import('../screens/MtoknaWindowSellerScreen'));
const MtoknaWindowsScreen = lazy(() => import('../screens/MtoknaWindowsScreen'));
const MtoknaDocumentsScreen = lazy(() => import('../screens/MtoknaDocumentsScreen'));
const MtoknaVideosScreen = lazy(() => import('../screens/MtoknaVideosScreen'));
const RainproOrdersScreen = lazy(() => import('../screens/RainproOrdersScreen'));
const RainproPickersScreen = lazy(() => import('../screens/RainproPickersScreen'));
const MtoknaExcelSchemesScreen = lazy(() => import('../screens/MtoknaExcelSchemesScreen'));
const MtoknaCreateExcelSchemeScreen = lazy(() => import('../screens/MtoknaCreateExcelSchemeScreen'));
const CabOrdersScreen = lazy(() => import('../screens/CabOrdersScreen'));
const PointsScreen = lazy(() => import('../screens/PointsScreen'));
const PointScreen = lazy(() => import('../screens/PointScreen'));
const FilesScreen = lazy(() => import('../screens/FilesScreen'));
const AiFunctionsScreen = lazy(() => import('../screens/AiFunctionsScreen'));
const AiFunctionScreen = lazy(() => import('../screens/AiFunctionScreen'));
const AiCommandsScreen = lazy(() => import('../screens/AiCommandsScreen'));
const AiCommandItemsScreen = lazy(() => import('../screens/AiCommandItemsScreen'));
const FullProductsScreen = lazy(() => import('../screens/FullProductsScreen'));
const AiAddonsScreen = lazy(() => import('../screens/AiAddonsScreen'));
const AiAddonScreen = lazy(() => import('../screens/AiAddonScreen'));
const AiChatbotQuestionsScreen = lazy(() => import('../screens/AiChatbotQuestionsScreen'));
const AiChatbotThreadsScreen = lazy(() => import('../screens/AiChatbotThreadsScreen'));
const AiChatbotThreadScreen = lazy(() => import('../screens/AiChatbotThreadScreen'));
const MtoknaNewslettersScreen = lazy(() => import('../screens/MtoknaNewslettersScreen'));
const MtoknaNewsletterScreen = lazy(() => import('../screens/MtoknaNewsletterScreen'));
const CategoriesScreen = lazy(() => import('../screens/CategoriesScreen'));
const AiTransactionsScreen = lazy(() => import('../screens/AiTransactionsScreen'));
const AiMailerQuestionsScreen = lazy(() => import('../screens/AiMailerQuestionsScreen'));
const AiMailerThreadsScreen = lazy(() => import('../screens/AiMailerThreadsScreen'));
const AiMailerThreadScreen = lazy(() => import('../screens/AiMailerThreadScreen'));
const EshopEnumsScreen = lazy(() => import('../screens/EshopEnumsScreen'));
const MtoknaCodesScreen = lazy(() => import('../screens/MtoknaCodesScreen'));
const RainproProductsScreen = lazy(() => import('../screens/RainproProductsScreen'));
const RainproCreateProductScreen = lazy(() => import('../screens/RainproCreateProductScreen'));
const RainproStoragesScreen = lazy(() => import('../screens/RainproStoragesScreen'));
const RainproStorageItemsScreen = lazy(() => import('../screens/RainproStorageItemsScreen'));
const RainproStorageLogsScreen = lazy(() => import('../screens/RainproStorageLogsScreen'));
const RainproSchemesScreen = lazy(() => import('../screens/RainproSchemesScreen'));
const RainproCreateSchemeScreen = lazy(() => import('../screens/RainproCreateSchemeScreen'));
const DropxlLogsScreen = lazy(() => import('../screens/DropxlLogsScreen'));
const RainproSellersScreen = lazy(() => import('../screens/RainproSellersScreen'));
const RainproPointsScreen = lazy(() => import('../screens/RainproPointsScreen'));
const RainproSellerOrdersScreen = lazy(() => import('../screens/RainproSellerOrdersScreen'));
const MtoknaCampaignsScreen = lazy(() => import('../screens/MtoknaCampaignsScreen'));
const MtoknaCreateCampaignScreen = lazy(() => import('../screens/MtoknaCreateCampaignScreen'));
const MtoknaCampaignTemplateScreen = lazy(() => import('../screens/MtoknaCampaignTemplateScreen'));
const MtoknaContactsScreen = lazy(() => import('../screens/MtoknaContactsScreen'));
const BlogScreen = lazy(() => import('../screens/BlogScreen'));
const MtoknaSellerComplaintsScreen = lazy(() => import('../screens/MtoknaSellerComplaintsScreen'));
const RainproLabelsScreen = lazy(() => import('../screens/RainproLabelsScreen'));
const EsatCreateSchemeScreen = lazy(() => import('../screens/EsatCreateSchemeScreen'));
const EsatProductsScreen = lazy(() => import('../screens/EsatProductsScreen'));
const EsatCreateProductScreen = lazy(() => import('../screens/EsatCreateProductScreen'));
const MtoknaOwnerPointsScreen = lazy(() => import('../screens/MtoknaOwnerPointsScreen'));
const MtoknaSellerNotesScreen = lazy(() => import('../screens/MtoknaSellerNotesScreen'));
const AiAgentsScreen = lazy(() => import('../screens/AiAgentsScreen'));
const AiAgentCommandsScreen = lazy(() => import('../screens/AiAgentCommandsScreen'));
const AiAgentScreen = lazy(() => import('../screens/AiAgentScreen'));
const RainproPointPackagesScreen = lazy(() => import('../screens/RainproPointPackagesScreen'));
const MtoknaManualInvoicesScreen = lazy(() => import('../screens/MtoknaManualInvoicesScreen'));
const RainproComplaintOrdersScreen = lazy(() => import('../screens/RainproComplaintOrdersScreen'));
const JoklUsersScreen = lazy(() => import('../screens/JoklUsersScreen'));
const JoklCreditsScreen = lazy(() => import('../screens/JoklCreditsScreen'));
const JoklOrdersScreen = lazy(() => import('../screens/JoklOrdersScreen'));
const JoklCouponsScreen = lazy(() => import('../screens/JoklCouponsScreen'));

const PublicComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const source = searchParams.get('source');

    return <PublicScreen
        location={location}
        navigate={navigate}
        params={params}
        source={source}
        key={`${location.pathname}${source}`}
    />
};

const AffiliateRegisterComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const name = searchParams.get('name');

    return <AffiliateRegisterScreen
        location={location}
        navigate={navigate}
        params={params}
        name={name}
        key={`${location.pathname}${name}`}
    />
};

const OrderPublicComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <OrderPublic
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const OrdersSellersComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <OrdersScreen
        location={location}
        navigate={navigate}
        params={params}
        key="sellers"
    />
};

const OrderMtOknaComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <OrderMtOknaScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const LoginComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <LoginScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const MtoknaOrdersComponent = ({ type }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaOrdersScreen
        location={location}
        navigate={navigate}
        params={{ ...params, type }}
        key={`${location.pathname}`}
    />
};

const MtoknaCreateOrderComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateOrderScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCreateProductComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateProductScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCreateSchemeComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateSchemeScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCreateExcelSchemeComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateExcelSchemeScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCreateDogComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateDogScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaTemplatesComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaTemplatesScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaTemplateComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaTemplateScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaNewsletterComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaNewsletterScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const RainproOrdersComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproOrdersScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const RainproSellerOrdersComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproSellerOrdersScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const CabOrdersComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <CabOrdersScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const PointComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <PointScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiFunctionComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiFunctionScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiCommandItemsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiCommandItemsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const FullProductsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <FullProductsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const CategoriesComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <CategoriesScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiAddonComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiAddonScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiChatbotThreadComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiChatbotThreadScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiChatbotQuestionsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiChatbotQuestionsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiMailerQuestionsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiMailerQuestionsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const AiMailerThreadComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiMailerThreadScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const RainproCreateProductComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproCreateProductScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const RainproStorageItemsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproStorageItemsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const RainproStorageLogsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproStorageLogsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const RainproCreateSchemeComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <RainproCreateSchemeScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCreateCampaignComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCreateCampaignScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaCampaignTemplateComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaCampaignTemplateScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const BlogComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <BlogScreen
        location={location}
        navigate={navigate}
        params={params}
        key={`${location.pathname}`}
    />
};

const MtoknaSellerComplaintsComponent = ({ type }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaSellerComplaintsScreen
        location={location}
        navigate={navigate}
        params={{ ...params, type }}
        key={`${location.pathname}`}
    />
};

const EsatCreateSchemeComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <EsatCreateSchemeScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const EsatCreateProductComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <EsatCreateProductScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MtoknaSellerNotesComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <MtoknaSellerNotesScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const AiAgentCommandsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiAgentCommandsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const AiAgentComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <AiAgentScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const JoklCreditsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <JoklCreditsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const JoklOrdersComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <JoklOrdersScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const JoklCouponsComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <JoklCouponsScreen
        location={location}
        navigate={navigate}
        params={params}
        key={location.pathname}
    />
};

const MARKET = getMarket();

export const preloadTranslations = async () => {
    if (MARKET === 'sk') {
        return;
    }

    global.translations = await loadTranslations(MARKET);
};

const loadTranslations = async (market) => {
    let module;

    switch (market) {
        case 'pl':
            module = await import('../translations/pl.json');
            break;

        case 'hu':
            module = await import('../translations/hu.json');
            break;

        case 'ro':
            module = await import('../translations/ro.json');
            break;

        case 'cz':
            module = await import('../translations/cz.json');
            break;

        case 'en':
        default:
            module = await import('../translations/en.json');
            break;
    }

    return module.default;
};

/**
 * Content komponenta.
 */
class Content extends Navigate {
    state = {
        loaded_translations: false,
    };

    async componentDidMount() {
        await preloadTranslations();

        this.setState({ loaded_translations: true });
    }

    /**
     * Rendrovanie.
     *
     * @return {JSX.Element}
     */
    render() {
        const { loaded_translations } = this.state;

        if (!loaded_translations) {
            return null;
        }

        const { user, location, navigate, params, cookies } = this.props;

        if (typeof cookies !== 'undefined') {
            let device_token = cookies.get(COOKIE_DEVICE_TOKEN_NAME, COOKIE_SETTINGS);

            if (typeof device_token === 'undefined') {
                device_token = getDeviceToken();

                cookies.set(COOKIE_DEVICE_TOKEN_NAME, device_token, COOKIE_SETTINGS);
            }

            global.device_token = device_token;
        }

        let openedMenu = true;

        if (!_.isEmpty(user)) {
            // Mame vyplneneho usera, pozrieme v akom stave je menu
            openedMenu = user.settings.menu !== 'mini';
        }

        // Zobrazujeme content ako mobilny
        const showMobileContent = this.isMobile() || _.includes(['/login', '/register'], this.getPath());

        // Zobrazujeme Webreal
        const showWebareal = this.isWebareal();

        if (_.includes(CUSTOM_ORDER_PAGES, window.location.host)) {
            return (
                <div className={`content ${!openedMenu ? 'closed' : ''} ${showMobileContent ? 'mobile' : ''} ${getCustomizationKey()}`}>
                    <Header location={location} navigate={navigate} params={params} />
                    <div className="content__screen">
                        <Suspense fallback={<div />}>
                            <Routes>
                                <Route path="/orders/public/:id/:token" element={<OrderPublicComponent />} />
                                <Route path="/orders/public/:id/:token/:market" element={<OrderPublicComponent />} />
                                <Route path="/" element={<OrderPublicComponent />} />
                                <Route path="*" element={<OrderPublicComponent />} />
                            </Routes>
                        </Suspense>
                    </div>
                </div>
            );
        }

        if (this.isMtokna()) {
            const showBanners = !_.isEmpty(user) && user.mtokna_type === 'mtokna_seller';

            return (
                <div className={`content ${!openedMenu ? 'closed' : ''} ${showMobileContent ? 'mobile' : ''} ${getCustomizationKey()}`}>
                    <Header location={location} navigate={navigate} params={params} />
                    <div className="content__screen">
                        {showBanners ? <MtoknaBanners location={location} navigate={navigate} params={params} /> : null}
                        <Suspense fallback={<div />}>
                            <Routes>
                                <Route path="/contacts" element={<MtoknaContactsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/campaigns/template/:id/:campaign_id/:type" element={<MtoknaCampaignTemplateComponent />} />
                                <Route path="/campaigns/view/:id" element={<MtoknaCreateCampaignComponent />} />
                                <Route path="/campaigns" element={<MtoknaCampaignsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/codes" element={<MtoknaCodesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/window-seller" element={<MtoknaWindowSellerScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/window-settings" element={<MtoknaWindowSettingsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/windows" element={<MtoknaWindowsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/dogs/view/:id" element={<MtoknaCreateDogComponent />} />
                                <Route path="/dogs" element={<MtoknaDogsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/dog-products" element={<MtoknaDogProductsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/excel-schemes/view/:id" element={<MtoknaCreateExcelSchemeComponent />} />
                                <Route path="/excel-schemes" element={<MtoknaExcelSchemesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/schemes/view/:id" element={<MtoknaCreateSchemeComponent />} />
                                <Route path="/schemes" element={<MtoknaSchemesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/products/view/:id" element={<MtoknaCreateProductComponent />} />
                                <Route path="/products/copy/:id" element={<MtoknaCreateProductComponent />} />
                                <Route path="/products" element={<MtoknaProductsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/categories" element={<MtoknaCategoriesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/complaints" element={<MtoknaComplaintsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/all-seller-complaints" element={<MtoknaSellerComplaintsComponent type="all" />} />
                                <Route path="/seller-complaints" element={<MtoknaSellerComplaintsComponent type="" />} />
                                <Route path="/customer-orders" element={<MtoknaManualCustomerOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/all-seller-orders" element={<MtoknaManualSellerOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/seller-accounting" element={<AccountingScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/seller-orders" element={<MtoknaManualSellerOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/seller-notes/:id" element={<MtoknaSellerNotesComponent />} />
                                <Route path="/banners" element={<MtoknaBannersScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/files" element={<MtoknaFilesScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/documents" element={<MtoknaDocumentsScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/videos" element={<MtoknaVideosScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/eshop" element={<MtoknaEshopScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/owner-smtp" element={<MtoknaOwnerSmtpScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/template/:id/:type" element={<MtoknaTemplateComponent />} />
                                <Route path="/templates/:type" element={<MtoknaTemplatesComponent />} />
                                <Route path="/templates" element={<MtoknaTemplatesScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/newsletter/:id" element={<MtoknaNewsletterComponent />} />
                                <Route path="/newsletters" element={<MtoknaNewslettersScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/manual/:type/:user_eshop_id/:id/:subtype" element={<MtoknaCreateOrderComponent />} />
                                <Route path="/manual/:type/:user_eshop_id/:id" element={<MtoknaCreateOrderComponent />} />
                                <Route path="/manual" element={<MtoknaManualOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/manual-seller" element={<MtoknaManualOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/invoices-manual" element={<MtoknaManualInvoicesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/invoices-manual-seller" element={<MtoknaManualInvoicesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/orders/mtokna/:id" element={<OrderMtOknaComponent />} />
                                <Route path="/orders" element={<MtoknaOrdersComponent type="all" />} />
                                <Route path="/points" element={<MtoknaPointsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/owner-points" element={<MtoknaOwnerPointsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/moderators" element={<MtoknaModeratorsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/owners" element={<MtoknaOwnersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/sellers" element={<MtoknaSellersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/dashboard/:search" element={<MtoknaOrdersComponent type="" />} />
                                <Route path="/dashboard" element={<MtoknaOrdersComponent type="" />} />} />
                                <Route path="/register" element={<RegisterScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/login" element={<LoginScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/" element={<LoginComponent />} />
                                <Route path="*" element={<LoginComponent />} />
                            </Routes>
                        </Suspense>
                    </div>
                </div>
            );
        } else if (this.isRainpro()) {
            return (
                <div className={`content ${!openedMenu ? 'closed' : ''} ${showMobileContent ? 'mobile' : ''} ${getCustomizationKey()}`}>
                    <Header location={location} navigate={navigate} params={params} />
                    <div className="content__screen">
                        <Suspense fallback={<div />}>
                            <Routes>
                                <Route path="/dashboard" element={<RainproOrdersComponent />} />} />
                                <Route path="/orders" element={<RainproOrdersComponent />} />} />
                                <Route path="/seller-orders" element={<RainproSellerOrdersComponent />} />} />
                                <Route path="/storage/:storage_id/:id" element={<RainproStorageLogsComponent />} />} />
                                <Route path="/storage/:id" element={<RainproStorageItemsComponent location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/storages" element={<RainproStoragesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/products/view/:id" element={<RainproCreateProductComponent />} />
                                <Route path="/products" element={<RainproProductsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/schemes/create/:url" element={<RainproCreateSchemeComponent />} />
                                <Route path="/schemes/view/:id" element={<RainproCreateSchemeComponent />} />
                                <Route path="/labels" element={<RainproLabelsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/schemes" element={<RainproSchemesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/pickers" element={<RainproPickersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/points" element={<RainproPointsScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/point-packages" element={<RainproPointPackagesScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/complaints" element={<RainproComplaintOrdersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/sellers" element={<RainproSellersScreen location={location} navigate={navigate} params={params} />} />} />
                                <Route path="/login" element={<LoginScreen location={location} navigate={navigate} params={params} />} />
                                <Route path="/" element={<LoginComponent />} />
                                <Route path="*" element={<LoginComponent />} />
                            </Routes>
                        </Suspense>
                    </div>
                </div>
            );
        }

        return (
            <div className={`content ${!openedMenu ? 'closed' : ''} ${showMobileContent ? 'mobile' : ''} ${showWebareal ? 'webreal-panel' : ''} ${getCustomizationKey()}`}>
                {showWebareal ? <Webareal navigate={navigate} /> : null}
                <Header location={location} navigate={navigate} params={params} />
                <div className="content__screen">
                    <Suspense fallback={<div />}>
                        <Routes>
                            <Route path="/admin" element={<AdminScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/orders/mtokna/:id/:edit_id" element={<OrderMtOknaComponent />} />
                            <Route path="/orders/mtokna/:id" element={<OrderMtOknaComponent />} />
                            <Route path="/orders/public/:id/:token" element={<OrderPublicComponent />} />
                            <Route path="/orders/public/:id/:token/:market" element={<OrderPublicComponent />} />
                            <Route path="/complaint/:id" element={<ComplaintScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/complaint" element={<ComplaintScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/complaints" element={<ComplaintsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/track-trace" element={<TrackTraceScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/marketplaces" element={<MarketplacesScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/settings" element={<SettingsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/notifications/high" element={<NotificationsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/notifications" element={<NotificationsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/employee/:id" element={<EmployeeScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/employee" element={<EmployeeScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/employees" element={<EmployeesScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/register" element={<RegisterScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/affiliate-portal" element={<AffiliatePortalScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/affiliate-register" element={<AffiliateRegisterComponent />} />
                            <Route path="/affiliate-login" element={<AffiliateLoginScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/login" element={<LoginScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/storage" element={<StorageScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/accounting" element={<AccountingScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/eshop" element={<EshopScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/eshop/enums" element={<EshopEnumsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/addons" element={<AddonsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/bank" element={<BmailsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/export/:id" element={<ExportScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/export" element={<ExportScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/template/:id" element={<TemplateScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/template" element={<TemplateScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/templates" element={<TemplatesScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/exports" element={<ExportsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/couriers" element={<LabelsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/payments" element={<InvoicePaymentsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/invoices" element={<InvoicesScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/clients" element={<ClientsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/orders/:search" element={<OrdersScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/orders" element={<OrdersScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/sellers-orders" element={<OrdersSellersComponent />} />
                            <Route path="/order" element={<OrderScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/payment-error" element={<DashboardScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/payment-success" element={<DashboardScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/dashboard-after-register" element={<DashboardScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/dashboard" element={<DashboardScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/cab/products" element={<CabProductsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/cab/orders/:type" element={<CabOrdersComponent />} />
                            <Route path="/jokl" element={<JoklUsersScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/jokl/credits/:id" element={<JoklCreditsComponent />} />
                            <Route path="/jokl/orders/:id" element={<JoklOrdersComponent />} />
                            <Route path="/jokl/coupons/:id" element={<JoklCouponsComponent />} />
                            <Route path="/maps" element={<PointsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/maps/view/:id/:user_courier_id" element={<PointComponent />} />
                            <Route path="/files" element={<FilesScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-functions" element={<AiFunctionsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-functions/view/:id" element={<AiFunctionComponent />} />
                            <Route path="/ai-commands" element={<AiCommandsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-commands/view/:id" element={<AiCommandItemsComponent />} />
                            <Route path="/ai-addons" element={<AiAddonsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-addons/view/:slug" element={<AiAddonComponent />} />
                            <Route path="/ai-agents" element={<AiAgentsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-agents/view/:slug/:id" element={<AiAgentComponent />} />
                            <Route path="/ai-agents/logs/:id" element={<AiAgentCommandsComponent />} />
                            <Route path="/ai-chatbot/questions" element={<AiChatbotQuestionsComponent />} />
                            <Route path="/ai-chatbot/questions/:message_id" element={<AiChatbotQuestionsComponent />} />
                            <Route path="/ai-chatbot/messages" element={<AiChatbotThreadsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-chatbot/messages/:id" element={<AiChatbotThreadComponent />} />
                            <Route path="/ai-mailer/questions" element={<AiMailerQuestionsComponent />} />
                            <Route path="/ai-mailer/questions/:message_id" element={<AiMailerQuestionsComponent />} />
                            <Route path="/ai-mailer/messages" element={<AiMailerThreadsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/ai-mailer/messages/:id" element={<AiMailerThreadComponent />} />
                            <Route path="/ai-transactions" element={<AiTransactionsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/dropxl-logs" element={<DropxlLogsScreen location={location} navigate={navigate} params={params} />} />
                            <Route path="/esat-products/view/:id" element={<EsatCreateProductComponent />} />
                            <Route path="/esat-products" element={<EsatProductsScreen location={location} navigate={navigate} params={params} />} />} />
                            <Route path="/products" element={<FullProductsComponent />} />
                            <Route path="/products/copy-ai/:ai_command_id" element={<FullProductsComponent />} />
                            <Route path="/products/categories" element={<CategoriesComponent />} />
                            <Route path="/products/categories/copy-ai/:ai_command_id" element={<CategoriesComponent />} />
                            <Route path="/blog" element={<BlogComponent />} />
                            <Route path="/blog/:article" element={<BlogComponent />} />
                            <Route path="/" element={<PublicComponent />} />
                            <Route path="/integration/:integration" element={<PublicComponent />} />
                            <Route path="/integration" element={<PublicComponent />} />
                            <Route path="*" element={<PublicComponent />} />
                        </Routes>
                    </Suspense>
                </div>
                <Chat location={location} navigate={navigate} params={params} />
            </div>
        );
    }
}

const stateToProps = ({ user }) => ({ user });

export default withCookies(connect(stateToProps, { setUser })(Content));
